var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import React, { useCallback, useState } from "react";
import { apiFetchBlob, LoadingIcon, HelpTooltip } from "ee-react-components";
import { process } from "../Process";
import { useAuth0 } from "@auth0/auth0-react";
/**
 * Reusable button component for downloading files via async requests.
 * Supports both GET and POST requests (POST when body is provided).
 * Automatically handles async task polling and displays loading state.
 */
export var DownloadAsyncFileButton = function (_a) {
    var resourceUrl = _a.resourceUrl, body = _a.body, _b = _a.labelIdle, labelIdle = _b === void 0 ? "Download" : _b, _c = _a.labelLoading, labelLoading = _c === void 0 ? "Downloading" : _c, _d = _a.variant, variant = _d === void 0 ? "default" : _d, tooltipMessage = _a.tooltipMessage;
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var download = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var getToken, url, args, blob, blobUrl, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    getToken = function () {
                        return getAccessTokenSilently({
                            authorizationParams: {
                                audience: process.env.AUTH0_AUDIENCE,
                            },
                        });
                    };
                    url = typeof resourceUrl === "function" ? resourceUrl() : resourceUrl;
                    args = {
                        method: body ? "POST" : "GET",
                        body: body,
                        callbacks: {
                            getToken: getToken,
                        },
                    };
                    setIsLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiFetchBlob(url, args)];
                case 2:
                    blob = _b.sent();
                    blobUrl = window.URL.createObjectURL(blob);
                    (_a = window.open(blobUrl, "_blank")) === null || _a === void 0 ? void 0 : _a.focus();
                    setIsLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    setIsLoading(false);
                    console.error("Error downloading file:", error_1);
                    alert("Failed to download file. Please try again.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [body, resourceUrl, getAccessTokenSilently]);
    var buttonClassName = variant === "blue"
        ? "px-[16px] py-[8px] rounded-[8px] bg-blue-700 hover:bg-blue-400 text-white w-fit flex flex-row gap-x-2 items-center"
        : "text-white hover:text-black-400 font-N8 whitespace-pre w-fit flex flex-row gap-x-2 items-center";
    return (React.createElement("div", { className: "flex flex-row gap-x-2 items-center" },
        React.createElement("button", { onClick: download, className: buttonClassName, disabled: isLoading },
            isLoading ? (React.createElement("div", { className: "w-6 h-6 flex items-center justify-center" }, LoadingIcon)) : (React.createElement(ArrowDownTrayIcon, { className: "h-6 w-6" })),
            isLoading ? labelLoading : labelIdle),
        tooltipMessage && React.createElement(HelpTooltip, { text: tooltipMessage })));
};
